import { render, staticRenderFns } from "./dept_detail.vue?vue&type=template&id=1c432ed8&scoped=true"
import script from "./dept_detail.vue?vue&type=script&lang=js"
export * from "./dept_detail.vue?vue&type=script&lang=js"
import style0 from "./dept_detail.vue?vue&type=style&index=0&id=1c432ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c432ed8",
  null
  
)

export default component.exports